import { useEffect, useState } from 'react';
import { LessonPlan, ShoppingListItem } from '../../../types/lessonPlan.type';
import { scaleScalableHtml } from '../../../utils/recipeScaleUtils';
import SafeHTMLDisplay from '../../common/SafeHTMLDisplay';
import './RecipeIngredients.css';

interface LessonPlanShoppingListProps {
  lessonPlan: LessonPlan;
}

const LessonPlanShoppingList = ({ lessonPlan }: LessonPlanShoppingListProps) => {
  const [shoppingList, setShoppingList] = useState<ShoppingListItem[]>([]);
  const [scaledShoppingList, setScaledShoppingList] = useState<ShoppingListItem[]>([]);
  const [scale, setScale] = useState(1);

  const applyScale = (items: ShoppingListItem[], newScale: number) =>
    items.map((item) => ({
      ...item,
      name: scaleScalableHtml(item.name, newScale)
    }));

  const handleScaleChange = (newScale: number) => {
    setScale(newScale);
    setScaledShoppingList(applyScale(shoppingList, newScale));
  };

  useEffect(() => {
    if (lessonPlan.shopping_list_items.length) {
      setShoppingList(lessonPlan.shopping_list_items);
      setScaledShoppingList(applyScale(lessonPlan.shopping_list_items, scale));
    }
  }, [lessonPlan]);

  return (
    <>
      <div
        className="ingredients"
        id="shopping-list"
      >
        <div className="scale mb-4">
          <div className="scale-copy">
            <div className="subheader tiny mb-0">scale</div>
          </div>
          {Array.from({ length: 7 }).map((_, index) => (
            <div
              onClick={() => handleScaleChange(index + 1)}
              className={`scale-amount scale-${index + 1}X ${scale === index + 1 ? 'active' : ''}`}
              key={`scale-${index}`}
            >
              <div>{index + 1}X</div>
            </div>
          ))}
        </div>
        <h3 className="text-info fw-bolder mb-4">Shopping List</h3>
        <ul
          role="list"
          className="w-list-unstyled"
        >
          {scaledShoppingList.map((shoppingListItem, index) => (
            <li key={`shopping-list-item-${index}`}>
              <SafeHTMLDisplay htmlContent={shoppingListItem.name} />
            </li>
          ))}
        </ul>
      </div>
      <div className="dots recipe"></div>
    </>
  );
};

export default LessonPlanShoppingList;
